// 初期表示時におすすめ順でソート
document.addEventListener('DOMContentLoaded', function() {
	const tables = document.querySelectorAll('.product-table-frontend');
	tables.forEach(function(tableContainer) {
		const tableId = tableContainer.querySelector('table').dataset.tableId;
		const recommendBtn = tableContainer.querySelector('.product-table-sort-btn.active');
		if (recommendBtn) {
			// 初期ソートを実行
			sortProductTable(tableId, 'recommend_score', recommendBtn, true);
		}
	});
});
function sortProductTable(tableId, sortBy, button, isInitialSort = false) {

	// テーブルコンテナを取得
	const container = document.getElementById(tableId);
	if (!container) {
		console.error('Container not found:', tableId);
		return;
	}

	// テーブル要素を取得
	const table = container.querySelector('.product-table[data-table-id="' + tableId + '"]');
	if (!table) {
		console.error('Table not found:', tableId);
		return;
	}

	const tbody = table.querySelector('tbody');
	const rows = Array.from(tbody.querySelectorAll('tr'));

	// 現在の状態を保持
	const wasActive = button.classList.contains('active');
	const wasAscending = button.classList.contains('ascending');

	// ソート方向を決定
	let isAscending = false; // デフォルトは降順

	// 初期ソートの場合は降順を維持
	if (isInitialSort) {
		isAscending = false;
	} else if (wasActive) {
		// 既にアクティブなボタンをクリックした場合は方向を切り替え
		isAscending = !wasAscending;
	}

	// 同じテーブルのボタンからのみアクティブクラスを削除
	const sameTableButtons = container.querySelectorAll('.product-table-sort-btn');
	sameTableButtons.forEach(function(btn) {
		tbody.classList.remove('sorted-ascending', 'sorted-descending');
		btn.classList.remove('active', 'ascending', 'descending');
	});

	// クリックされたボタンにアクティブクラスを追加
	button.classList.add('active');
	button.classList.add(isAscending ? 'ascending' : 'descending');
	tbody.classList.add(isAscending ? 'sorted-ascending' : 'sorted-descending');

	// 行をソート（data-sort-info属性を使用）
	rows.sort(function(a, b) {
		// data-sort-info属性からJSONデータを取得
		const aData = a.dataset.sortInfo ? a.dataset.sortInfo.replace(/[\n\t]/g, '') : '';
		const bData = b.dataset.sortInfo ? b.dataset.sortInfo.replace(/[\n\t]/g, '') : '';
		// console.log('Row data - A:', aData, 'B:', bData);

		let aValue, bValue;

		if (sortBy === 'recommend_score') {
			// おすすめスコアでソート
			const aJson = aData ? JSON.parse(aData) : {};
			const bJson = bData ? JSON.parse(bData) : {};
			aValue = aJson.recommend_score || 0;
			bValue = bJson.recommend_score || 0;
		} else if (sortBy === 'price') {
			// 価格でソート - JSONから価格を取得
			const aJson = aData ? JSON.parse(aData) : {};
			const bJson = bData ? JSON.parse(bData) : {};
			aValue = aJson.price || 0;
			bValue = bJson.price || 0;
		}

		// console.log('Sort values - A:', aValue, 'B:', bValue);

		// ソート方向に応じて並び替え
		if (isAscending) {
			return aValue - bValue;
		} else {
			return bValue - aValue;
		}
	});

	// 既存のランキング数字を削除
	const currentTable = document.querySelector(`table[data-table-id="${tableId}"]`);
	const existingRankings = currentTable.querySelectorAll('.ranking-count');
	existingRankings.forEach(function(ranking) {
		ranking.remove();
	});

	// DOMを更新
	tbody.innerHTML = '';
	const totalRows = rows.length;
	rows.forEach(function(row, index) {
		// ランキング数字を追加（昇順の場合は逆順の番号を付ける）
		const count = isAscending ? (totalRows - index) : (index + 1);
		const firstCell = row.querySelector('td:first-child');
		if (firstCell) {
			const rankingSpan = document.createElement('span');
			rankingSpan.className = `ranking-count --count-${count}`;
			rankingSpan.textContent = count;
			firstCell.insertBefore(rankingSpan, firstCell.firstChild);
		}
		tbody.appendChild(row);
	});
}
// let currentSort = "recommend";
// let sortDirection = "desc";

// // ソート関数
// function sortTable(sortType, event) {
//   // ボタンの状態を更新
//   document.querySelectorAll(".sort-btn").forEach((btn) => {
//     btn.classList.remove("active");
//   });

//   if (event && event.target) {
//     event.target.classList.add("active");
//   }

//   const table = document.getElementById("productTable");
//   if (!table) return; // テーブルが存在しない場合は処理を中止

//   const tbody = table.querySelector("tbody");
//   if (!tbody) return; // tbodyが存在しない場合は処理を中止

//   const rows = Array.from(tbody.querySelectorAll("tr"));

//   // ソート方向を決定
//   if (currentSort === sortType) {
//     sortDirection = sortDirection === "desc" ? "asc" : "desc";
//   } else {
//     sortDirection = "desc";
//   }
//   currentSort = sortType;

//   // データ属性に基づいてソート
//   rows.sort((a, b) => {
//     let aVal, bVal;

//     switch (sortType) {
//       case "recommend":
//         aVal = parseInt(a.dataset.recommend);
//         bVal = parseInt(b.dataset.recommend);
//         break;
//       case "cospa":
//         aVal = parseInt(a.dataset.cospa);
//         bVal = parseInt(b.dataset.cospa);
//         break;
//       case "popularity":
//         aVal = parseInt(a.dataset.popularity);
//         bVal = parseInt(b.dataset.popularity);
//         return aVal - bVal;
//     }

//     return sortDirection === "desc" ? bVal - aVal : aVal - bVal;
//   });

//   // 順位を更新
//   rows.forEach((row, index) => {
//     const rankCell = row.querySelector(".rank-cell");
//     if (rankCell) {
//       rankCell.textContent = index + 1;
//     }
//   });

//   // テーブルを再構築
//   tbody.innerHTML = "";
//   rows.forEach((row) => tbody.appendChild(row));
// }

// // 初期化関数を作成
// function initializeRanking() {
//   // 各ソートボタンにイベントリスナーを追加
//   document.querySelectorAll(".sort-btn").forEach((btn) => {
//     // 既にイベントリスナーが追加済みかチェック
//     if (btn.dataset.listenerAdded) {
//       return;
//     }
    
//     btn.addEventListener("click", function (e) {
//       sortTable(this.dataset.sorttype, e);
//     });
    
//     // 処理済みマークを追加
//     btn.dataset.listenerAdded = 'true';
//   });

//   // テーブルの横スクロール処理
//   const tableWrapper = document.querySelector(".table-wrapper");
//   if (tableWrapper && !tableWrapper.dataset.scrollListenerAdded) {
//     tableWrapper.addEventListener("scroll", function () {
//       const fixedColumns = document.querySelectorAll(".fixed-columns");
//       const scrollLeft = this.scrollLeft;

//       fixedColumns.forEach((col) => {
//         col.style.boxShadow = scrollLeft > 0
//           ? "2px 0 5px rgba(0,0,0,0.2)"
//           : "2px 0 5px rgba(0,0,0,0.1)";
//       });
//     });
    
//     // 処理済みマークを追加
//     tableWrapper.dataset.scrollListenerAdded = 'true';
//   }

//   // 初期ソート（テーブルが存在する場合のみ）
//   if (document.getElementById("productTable")) {
//     sortTable("recommend");
//   }
// }

// // DOMContentLoaded時の初期化
// document.addEventListener('DOMContentLoaded', initializeRanking);

// // 動的コンテンツ挿入後の再初期化用（グローバル関数として公開）
// window.initializeRanking = initializeRanking;